export enum OrderType {
  DELIVERY = "DELIVERY",
  PICKUP = "PICKUP",
}